<script>
import { Doughnut, mixins } from 'vue-chartjs'
import 'chartjs-plugin-colorschemes'
import { Tableau20 } from 'chartjs-plugin-colorschemes/src/colorschemes/colorschemes.tableau'

export default {
  name: 'DoughnutChart',
  extends: Doughnut,
  mixins: [mixins.reactiveProp],
  data: () => ({
    options: {
      responsive: true,
      maintainAspectRatio: false,
      elements: {
        line: {
          fill: false
        }
      },
      plugins: {
        colorschemes: {
          scheme: Tableau20
        }
      }
    }
  }),
  mounted () {
    this.renderChart(this.chartData, this.options)
  }
}
</script>

<style scoped>

</style>
